import ArticlesCollectionModule from './ArticlesCollectionModule';

export * from './ArticlesCollectionModule';
export default ArticlesCollectionModule;
